import Modal from 'react-modal';

import { formatDate, getTheHoursAndMinutes, handelVacatinTypeShow, vacationStatusCheck } from '../../../libs/generalFunctions';
import useFetchAttach from '../../../customHooks/useFetchAttach';

import { HiDownload } from "react-icons/hi";

import './modalCompMainPage.scss';


function ModalCompMainPage({ isOpen , closeFun , data }) {

const { handleDownloadTheAttachs , LoadingFilesToDownload } = useFetchAttach();      

//====Event handler start here====

  //show the vacation endtime
  const vacatoinTimeShow = (obj,timeType)=>{
    if(timeType === "end_time"){
  
    if(obj.type === "EXIT_PERMISSION" ){
      return (
       <div style={{display:"flex",flexDirection:"row",gap:".5rem"}}>
         <span>{obj.start_date && formatDate(obj.start_date)}</span>
         <span>({obj.start_date && getTheHoursAndMinutes(obj.start_date)})</span>
       </div>
      );
    }
    else if(obj.type === "MISSION"){
     return (
       <div style={{display:"flex",flexDirection:"row",gap:".5rem"}}>
         <span>{obj.end_date && formatDate(obj.end_date)}</span>
         <span>({obj.end_date && getTheHoursAndMinutes(obj.end_date)})</span>
       </div>
      );
    }
    else{
     if(obj.end_date){
      return formatDate(obj.end_date);
    }
    else{
      return "";
    }
    }
   }
   else if(timeType === "start_time"){
  
     if(obj.type === "EXIT_PERMISSION" ){
       return (
        <div style={{display:"flex",flexDirection:"row",gap:".5rem"}}>
          <span>{obj.start_date && formatDate(obj.start_date)}</span>
          <span>({obj.start_date && getTheHoursAndMinutes(obj.start_date)})</span>
        </div>
       );
     }
     else if(obj.type === "MISSION"){
      return (
        <div style={{display:"flex",flexDirection:"row",gap:".5rem"}}>
          <span>{obj.start_date && formatDate(obj.start_date)}</span>
          <span>({obj.start_date && getTheHoursAndMinutes(obj.start_date)})</span>
        </div>
       );
     }
     else{
      if(obj.start_date){
        return formatDate(obj.start_date);
      }
      else{
        return "";
      }

     }
    }
   }

//====Event handler end here====


  return (
<div>
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={closeFun}
        className="ModalCompMainPage_dev"
        overlayClassName="ModalCompMainPage_overlay"
      >
        <div className='ModalCompMainPage_items'>
        <div className='modal_item' >
        <span className='modal_item_text modal_item_label' dir='rtl'>نوع الاجازة:</span>
        <span className='modal_item_text' dir='rtl'>{data.type && handelVacatinTypeShow(data.type)}</span>
        </div>

        <div className='modal_item' >
        <span className='modal_item_text modal_item_label' dir='rtl'>تبدأ في:</span>
        <span className='modal_item_text' dir='rtl'>{vacatoinTimeShow(data,"start_time")}</span>
        </div>

        <div className='modal_item' >
        <span className='modal_item_text modal_item_label' dir='rtl'>تنتهي في:</span>
        <span className='modal_item_text' dir='rtl'>{vacatoinTimeShow(data,"end_time")}</span>
        </div>

        <div className='modal_item' >
        <span className='modal_item_text modal_item_label' dir='rtl'>السبب:</span>
        <span className='modal_item_text' dir='rtl'>{data.reasons && data.reasons}</span>
        </div>

        <div className='modal_item' >
        <span className='modal_item_text modal_item_label' dir='rtl'>الحالة:</span>
        <span className='modal_item_text' dir='rtl'>{data.status && vacationStatusCheck(data.status)}</span>
        </div>

        {
          ( data?.files && Array.isArray( data.files ) && data.files.length > 0 ) &&
          ( <button className='btn_download_Attach'
             onClick={()=>{ handleDownloadTheAttachs( data.files ) }} 
             disabled = { LoadingFilesToDownload }
             dir='rtl'>
              {
               ( LoadingFilesToDownload ) 
               ?   
               ( <span className = "loading_text" dir = "rtl" >يتم التحميل ...</span> )
               :
               ( <div className = "btn_download_Attach_iconAndText">
                 <span className="btn_download_Attach_text" dir="rtl">تحميل المرفقات</span>
                 <HiDownload className = "btn_download_Attach_icon"/>
               </div> )
              }                       
             </button> )
                }


        <div className='btn_cover_ModalElment'>
         <button onClick={()=>{closeFun()}} className='btn_forMoal btn_close_modal'>اغلاق</button>
         </div>
        </div>



      </Modal>
    </div>
  )
}

export default ModalCompMainPage;